/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { SmsProcess } from '../model/smsProcess';
import { SmsProcessingListconfig } from '../model/smsProcessingListconfig';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SmsProcessService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessAddSmsProcess(model: SmsProcess, observe?: 'body', reportProgress?: boolean): Observable<SmsProcess>;
    public smsProcessAddSmsProcess(model: SmsProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsProcess>>;
    public smsProcessAddSmsProcess(model: SmsProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsProcess>>;
    public smsProcessAddSmsProcess(model: SmsProcess, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsProcessAddSmsProcess.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SmsProcess>(`${this.basePath}/api/SmsProcess/createProcess`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessDeleteSmsProcess(model: SmsProcess, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsProcessDeleteSmsProcess(model: SmsProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsProcessDeleteSmsProcess(model: SmsProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsProcessDeleteSmsProcess(model: SmsProcess, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsProcessDeleteSmsProcess.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<boolean>(`${this.basePath}/api/SmsProcess/deleteProcess`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessGetAllProcess(model: SmsProcess, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsProcess>>;
    public smsProcessGetAllProcess(model: SmsProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsProcess>>>;
    public smsProcessGetAllProcess(model: SmsProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsProcess>>>;
    public smsProcessGetAllProcess(model: SmsProcess, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsProcessGetAllProcess.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<SmsProcess>>(`${this.basePath}/api/SmsProcess/smsProcesses`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessGetProcessById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsProcess>;
    public smsProcessGetProcessById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsProcess>>;
    public smsProcessGetProcessById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsProcess>>;
    public smsProcessGetProcessById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsProcess>(`${this.basePath}/api/SmsProcess/smsProcess`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessGetProcessByName(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SmsProcess>;
    public smsProcessGetProcessByName(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SmsProcess>>;
    public smsProcessGetProcessByName(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SmsProcess>>;
    public smsProcessGetProcessByName(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SmsProcess>(`${this.basePath}/api/SmsProcess/smsProcessname`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param config 
     * @param processtype 
     * @param ascendingorder 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessGetProcessConfig(config: SmsProcessingListconfig, processtype?: number, ascendingorder?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<SmsProcess>>;
    public smsProcessGetProcessConfig(config: SmsProcessingListconfig, processtype?: number, ascendingorder?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SmsProcess>>>;
    public smsProcessGetProcessConfig(config: SmsProcessingListconfig, processtype?: number, ascendingorder?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SmsProcess>>>;
    public smsProcessGetProcessConfig(config: SmsProcessingListconfig, processtype?: number, ascendingorder?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (config === null || config === undefined) {
            throw new Error('Required parameter config was null or undefined when calling smsProcessGetProcessConfig.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (processtype !== undefined && processtype !== null) {
            queryParameters = queryParameters.set('processtype', <any>processtype);
        }
        if (ascendingorder !== undefined && ascendingorder !== null) {
            queryParameters = queryParameters.set('ascendingorder', <any>ascendingorder);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.get<Array<SmsProcess>>(`${this.basePath}/api/SmsProcess/smsProcessconfiguration`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public smsProcessUpdateSmsProcess(model: SmsProcess, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public smsProcessUpdateSmsProcess(model: SmsProcess, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public smsProcessUpdateSmsProcess(model: SmsProcess, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public smsProcessUpdateSmsProcess(model: SmsProcess, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling smsProcessUpdateSmsProcess.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SmsProcess/updateProcess`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
